export function splitRestaurantName(name) {
  const trimmed = String(name || "").trim();
  if (!trimmed) return { first: "", second: "" };

  const spaceIndex = trimmed.indexOf(" ");
  if (spaceIndex > 0) {
    return {
      first: trimmed.slice(0, spaceIndex),
      second: trimmed.slice(spaceIndex + 1),
    };
  }

  const mid = Math.ceil(trimmed.length / 2);
  return {
    first: trimmed.slice(0, mid),
    second: trimmed.slice(mid),
  };
}

export function resolveStorytellingNameParts(restaurantName, options = {}) {
  const customPrimary = String(options.namePartPrimary ?? "").trim();
  const customAccent = String(options.namePartAccent ?? "").trim();

  const trimmed = String(restaurantName || "").trim();
  let autoPrimary = "";
  let autoAccent = "";

  if (trimmed) {
    const splitIndex = options.nameSplitIndex;
    if (
      typeof splitIndex === "number" &&
      Number.isInteger(splitIndex) &&
      splitIndex > 0 &&
      splitIndex < trimmed.length
    ) {
      autoPrimary = trimmed.slice(0, splitIndex);
      autoAccent = trimmed.slice(splitIndex);
    } else {
      const split = splitRestaurantName(trimmed);
      autoPrimary = split.first;
      autoAccent = split.second;
    }
  }

  return {
    primary: customPrimary || autoPrimary,
    accent: customAccent || autoAccent,
  };
}

export function formatStorytellingCityLabel(city) {
  if (!city) return "";
  try {
    return decodeURIComponent(city).replace(/-/g, " ").trim();
  } catch {
    return String(city).replace(/-/g, " ").trim();
  }
}

export function getStorytellingRomanLabel(index) {
  const ROMAN_NUMERALS = [
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
  ];
  return ROMAN_NUMERALS[index] || String(index + 1);
}

export function formatStorytellingChapterLabel(chapterLabel, _romanNumeral, t) {
  const custom = String(chapterLabel || "").trim();
  if (custom) return custom.toUpperCase();
  return t("storytellingChapterWord").toUpperCase();
}

export function buildStorytellingMetaLine(options = {}) {
  const parts = [];

  const city = String(options.cityLabel || "").trim();
  if (city) parts.push(city.toUpperCase());

  const address = String(options.address || "").trim();
  if (address) {
    const shortAddress = address.split(",")[0]?.trim() || address;
    if (shortAddress && !parts.includes(shortAddress.toUpperCase())) {
      parts.push(shortAddress.toUpperCase());
    }
  }

  const tagline = String(options.tagline || "").trim();
  if (tagline) parts.push(tagline.toUpperCase());

  return parts.length ? parts.join("  ·  ") : null;
}
